export default {
  _101: 'Čekáme na provedení online platby.',
  _102: 'Čekáme na provedení offline platby.',
  _3001: 'Bankovní platba potvrzena avízem.',
  _3002: 'Bankovní platba potvrzena výpisem.',
  _3003: 'Bankovní platba nebyla potvrzena.',
  _5001: 'Schváleno s nulovou částkou',
  _5002:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu dosažení limitů na platební kartě.',
  _5003:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problémů na straně vydavatele platební karty.',
  _5004:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problému na straně vydavatele platební karty.',
  _5005:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu zablokované platební karty.',
  _5006:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu nedostatku peněžních prostředků na platební kartě.',
  _5007:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu expirované platební karty.',
  _5008:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu zamítnutí CVV/CVC kódu.',
  _5009: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _5015: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _5017: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _5018: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _5019: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _6502: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _6504: 'Zamítnutí platby v systému 3D Secure banky zákazníka.',
  _5010:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problémů na platební kartě.',
  _5014:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problémů na platební kartě.',
  _5011:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problémů na účtu platební karty.',
  _5036:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu problémů na účtu platební karty.',
  _5012:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu technických problémů v autorizačním centru banky zákazníka.',
  _5013:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu chybného zadání čísla platební karty.',
  _5016:
    'Zamítnutí platby v autorizačním centru banky zákazníka, platba nebyla povolena na platební kartě zákazníka.',
  _5020: 'Neznámá konfigurace',
  _5021:
    'Zamítnutí platby v autorizačním centru banky zákazníka z důvodu dosažení nastavených limitů na platební kartě.',
  _5022:
    'Nastal technický problém spojený s autorizačním centrem banky zákazníka.',
  _5023: 'Platba nebyla provedena.',
  _5038: 'Platba nebyla provedena.',
  _5024:
    'Platba nebyla provedena. Platební údaje nebyly zadány v časovém limitu na platební bráně.',
  _5025:
    'Platba nebyla provedena. Konkrétní důvod zamítnutí je sdělen přímo zákazníkovi.',
  _5026:
    'Platba nebyla provedena. Součet kreditovaných částek překročil uhrazenou částku.',
  _5027: 'Platba nebyla provedena. Uživatel není oprávněn k provedení operace.',
  _5028:
    'Platba nebyla provedena. Částka k úhradě překročila autorizovanou částku.',
  _5029: 'Platba zatím nebyla provedena.',
  _5030: 'Platba nebyla provedena z důvodu opakovaného zadání platby.',
  _5031: 'Při platbě nastal technický problém na straně banky.',
  _5033: 'SMS se nepodařilo doručit.',
  _5035:
    'Platební karta je vydaná v regionu, ve kterém nejsou podporovány platby kartou.',
  _5037: 'Držitel platební karty zrušil platbu.',
  _5039:
    'Platba byla zamítnuta v autorizačním centru banky zákazníka z důvodu zablokované platební karty.',
  _5040: 'Duplicitni reversal transakce',
  _5041: 'Duplicitní transakce',
  _5042: 'Bankovní platba byla zamítnuta.',
  _5043: 'Platba zrušena uživatelem.',
  _5044: 'SMS byla odeslána. Zatím se ji nepodařilo doručit.',
  _5045:
    'Platba byla přijata. Platba bude připsána po zpracování v síti Bitcoin.',
  _5046: 'Platba nebyla uhrazena v plné výši.',
  _5047: 'Platba byla provedena po splatnosti.'
}
